export interface Connection {
  id: string
  name: string
  provider: string
  toolkit_slug: string | null
  sync_status: string | null
  status: string
  expires_at: string | null
  connected_at: string | null
  link_revoked: boolean
  expired: boolean
  share_url: string | null
  organization_id: string | null
  organization_detached: boolean
  project_id: string | null
  worker_ids: string[]
  assignable: boolean
  lock_version: number
  events: { action: string; actor: string | null; created_at: string }[]
}
export interface Target { id: string; name: string; organization_id: string; native_codex?: boolean; administrative?: boolean }
export interface Project extends Target { worker_ids: string[] }
export interface Copy extends Record<string, string | Record<string, string>> {
  providers: Record<string, string>
  statuses: Record<string, string>
  actions: Record<string, string>
  sync_statuses: Record<string, string>
}
export interface Props {
  page_title: string
  copy: Copy
  connections: Connection[]
  organizations: { id: string; name: string }[]
  workers: Target[]
  projects: Project[]
  toolkits: { slug: string; name: string }[]
  validity_options: { value: string; label: string }[]
  pagination: { page: number; total: number; pages: number }
}
export const fieldClass = 'mt-1 w-full rounded-md border border-border bg-background px-3 py-2 text-sm text-foreground focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring'
export const buttonClass = 'rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground hover:opacity-90 disabled:opacity-50'
export const secondaryClass = 'rounded-md border border-border px-3 py-2 text-sm hover:bg-muted disabled:opacity-50'
export function label(copy: Copy, key: string): string { return String(copy[key] ?? key) }
export function date(value: string): string { return new Intl.DateTimeFormat('pt-BR', { dateStyle: 'short', timeStyle: 'short' }).format(new Date(value)) }
